const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x1f36f067f4e425994763da9ee5bcc76f154c82d1',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x362316b94AEc405B8fFF2446FBeBe07e59dCAd0f'
}

export default priceContracts